// File: frontend/src/components/GDPRConsent/GDPRConsentPopup.js

import React, { useState } from 'react';
import { useGDPRConsent } from '../../contexts/GDPRConsentContext';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './GDPRConsentPopup.module.css';
import PrivacyPolicyContent from './PolicyContents/PrivacyPolicyContent';
import TermsOfServiceContent from './PolicyContents/TermsOfServiceContent';

const GDPRConsentPopup = () => {
  const { acceptConsent, rejectConsent } = useGDPRConsent();
  const { t } = useLanguage();
  const [viewingPolicy, setViewingPolicy] = useState(null); // null, 'privacy', or 'terms'

  const renderMainContent = () => (
    <>
      <div className={styles.header}>
        <h2>{t('gdpr.title', 'Cookie Consent')}</h2>
      </div>
      
      <div className={styles.content}>
        <p>
          {t('gdpr.main_text', 'We use essential cookies to ensure the basic functionality of our website and to enhance security. These cookies are necessary to prevent cyber attacks and fraud.')}
        </p>
        
        <div className={styles.consentExplanation}>
          <p>
            {t('gdpr.data_usage', 'We only collect necessary data such as cookies and IP addresses to help maintain security and prevent fraud. We never sell your data to third parties or marketing agencies.')}
          </p>
          <p>
            {t('gdpr.consent_choice', 'By clicking "Accept", you agree to our cookie policy. If you do not consent, click "Decline" to exit this site.')}
          </p>
        </div>
        
        <div className={styles.privacyLinks}>
          <button 
            className={styles.policyLink} 
            onClick={() => setViewingPolicy('privacy')}
          >
            {t('gdpr.privacy_policy', 'Privacy Policy')}
          </button>
          <button 
            className={styles.policyLink} 
            onClick={() => setViewingPolicy('terms')}
          >
            {t('gdpr.terms_of_service', 'Terms of Service')}
          </button>
        </div>
      </div>
      
      <div className={styles.actions}>
        <button 
          className={`${styles.button} ${styles.acceptButton}`}
          onClick={acceptConsent}
        >
          {t('gdpr.accept', 'Accept')}
        </button>
        <button 
          className={`${styles.button} ${styles.declineButton}`}
          onClick={rejectConsent}
        >
          {t('gdpr.decline', 'Decline')}
        </button>
      </div>
    </>
  );

  const renderPolicyViewer = () => {
    const isPolicyPrivacy = viewingPolicy === 'privacy';
    
    return (
      <>
        <div className={styles.policyHeader}>
          <button 
            className={styles.backButton} 
            onClick={() => setViewingPolicy(null)}
          >
            {t('gdpr.back')}
          </button>
          <h2>
            {isPolicyPrivacy 
              ? t('gdpr.privacy_policy_title', 'Privacy Policy') 
              : t('gdpr.terms_of_service_title', 'Terms of Service')}
          </h2>
        </div>
        
        <div className={`${styles.policyContent} ${styles.scrollable}`}>
          {isPolicyPrivacy ? <PrivacyPolicyContent /> : <TermsOfServiceContent />}
        </div>
        
        <div className={styles.policyActions}>
          <button 
            className={styles.backButton} 
            onClick={() => setViewingPolicy(null)}
          >
            {t('gdpr.back_to_consent', 'Back to Consent')}
          </button>
        </div>
      </>
    );
  };

  return (
    <div className={styles.overlay}>
      <div className={`${styles.popup} ${viewingPolicy ? styles.expanded : ''}`}>
        {viewingPolicy ? renderPolicyViewer() : renderMainContent()}
      </div>
    </div>
  );
};

export default GDPRConsentPopup;